import {
  GET_DROPSHIP_FEED_REQUEST,
  GET_DROPSHIP_FEED_SUCCESS,
  GET_DROPSHIP_FEED_ERROR
} from "../actions/types";

export default function (state = [], action) {
  const { type, payload } = action;
  switch (type) {
    case GET_DROPSHIP_FEED_REQUEST:
      return {
        loading: true,
      };
    case GET_DROPSHIP_FEED_SUCCESS:
      return {
        ...state,
        loading: false,
        payload,
      };
    case GET_DROPSHIP_FEED_ERROR:
      return {
        ...state,
        loading: false,
      };
    default:
      return state;
  }
}
